import { Chip, Dialog, DialogContent, DialogTitle, Typography, useTheme } from '@mui/material';
import { useSnackbar } from '@/commons/snackbar';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createTransactionService } from '@/services/cash-register';
import { errorCashRegister, warningCashRegister } from '@/utils/errors';
import { useState } from 'react';
import { useCashRegisterContext } from '@/hooks/useCashRegisterContext';
import { useAuthContext } from '@/hooks/useAuthContext';
import { translates } from '@/utils';
import {schemaType} from "@modules/cash-register/form/transaction/validations";
import { CashTransaction } from '../../types';
import CashTransactionForm from '../../form/transaction';

interface SimpleDialogProps {
  isWithdrawal: boolean;
  queryKey?: string[][];
}

export function TransactionModal(props: SimpleDialogProps) {
  const { isWithdrawal, queryKey } = props;
  const { box } = useCashRegisterContext();
  const { user } = useAuthContext();
  const [open, setOpen] = useState(false);

  const handleDialog = () => {
    setOpen((prev) => !prev);
  };

  const generateError = (value: any) => {
    const errorTemp = Array.isArray(value?.details) ? value?.details[0] : value;
    const errorMessage = errorCashRegister[errorTemp?.message];
    const warningMessage = warningCashRegister[errorTemp?.message];
    enqueueSnackbar(errorMessage ?? warningMessage ?? errorTemp?.message, {
      variant: warningMessage ? 'warning' : 'error',
    });
  };

  const { typography } = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const { mutateAsync, isSuccess } = useMutation({
    mutationFn: createTransactionService,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cash-register'] });
      queryClient.invalidateQueries({ queryKey: ['transactions'] });
      queryKey?.forEach((itemKey) => queryClient.invalidateQueries({ queryKey: itemKey }));
      enqueueSnackbar('create transaction!');
    },
    onError: generateError,
  });
  const handleSubmit = async (dataForm: schemaType) => {
    const atmUser = box?.actmUserOpen?.uid;
    const responsible = user?.uid ?? ''

    const newData: Partial<CashTransaction> = {
      ...dataForm, isWithdrawal, atmUser, responsible,
    };
    await mutateAsync(newData);
    handleDialog();
  };
  return (
    <>
      <Chip
        onClick={handleDialog}
        color={isWithdrawal ? 'warning' : 'info'}
        variant="outlined"
        label={isWithdrawal ? [translates.withdraw] : [translates.makeDeposit]}
      />
      <Dialog onClose={handleDialog} open={open} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Typography sx={{ ...typography.h6 }} textAlign="center">
            {isWithdrawal ? [translates.withdraw] : [translates.makeDeposit]}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <CashTransactionForm isWithdrawal={isWithdrawal} onSave={handleSubmit} isLoading={!isSuccess} />
        </DialogContent>
      </Dialog>
    </>
  );
}
